import { Alert, Button, IconButton } from "@mui/material";
import { getPlural } from "src/utils/string/getPlural";
import { CloseIcon } from "@ui-icons";
import { useTokenExpiryBanner } from "./TokenExpiryBanner.hooks";
import { daysUntilExpiry } from "./TokenExpiryBanner.utils";

export default function TokenExpiryBanner() {
  const { expiringTokens, visible, hide, openTokenSettings } =
    useTokenExpiryBanner();

  if (!visible) return null;

  const soonest = expiringTokens[0];
  const tokenLabel = soonest?.label?.trim() || "Unlabeled token";
  const daysRemaining = soonest ? daysUntilExpiry(soonest.expires_at) : 0;
  const dayWord = getPlural(daysRemaining, "day");
  const tokenCount = expiringTokens.length;

  return (
    <Alert
      severity="warning"
      className="rounded-none! items-center py-1"
      data-test-id="token-expiry-banner"
      action={
        <div className="flex items-center gap-1">
          <Button color="inherit" size="small" onClick={openTokenSettings}>
            Manage tokens
          </Button>
          <IconButton
            color="inherit"
            size="small"
            onClick={hide}
            aria-label="Dismiss token expiry banner"
            data-test-id="token-expiry-banner-dismiss"
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>
      }
    >
      {tokenCount === 1
        ? `Your token “${tokenLabel}” expires in ${daysRemaining} ${dayWord}. Generate a replacement in System Settings to avoid losing access.`
        : `${tokenCount} tokens expire within 30 days. The soonest, “${tokenLabel}”, expires in ${daysRemaining} ${dayWord}.`}
    </Alert>
  );
}
